import request from '@/utils/request';

let equipmentApi = {
    // 设备列表
    getEquipmentList(data, err) {
        return request._get('/shop/device/device/storeSelectList', data, err);
    },
    // 设备详情
    getEquipmentDetail(data, err) {
        return request._get('/shop/device/device/storeDetails', data, err);
    },

    // 用户下拉列表
    getEquipmentSelectList(data, err) {
        return request._get('/shop/user/user/selectList', data, err);
    },

    // 下拨
    getEquipmentPullDown(data, err) {
        return request._postBody('/shop/device/device/storeAllocated', data, err);
    },

    // 回拨
    getEquipmentCallBack(data, err) {
        return request._postBody('/shop/device/device/storeCallback', data, err);
    },

    // 设备导入
    addEquipment(data, err) {
        return request._upload('/shop/device/device/storeImportDevice', data, err);
    },
   //设备解绑
    UnbindDevice(data,err){
      return request._postBody('/shop/device/device/unbindDevice', data, err);
    }

}


export default equipmentApi;



// WEBPACK FOOTER //
// ./src/api/equipment/messagecontrol.js